import { ReactElement, useState } from "react";
import FilterComponentBase from "../../../components/filterComponentBase";
import { useFetch } from "../../../system/useFetch";
import { IContentAreaProps, IFilterData, IProduction, IState } from "../../../types";
import { useSelector } from "react-redux";
import { Alert, Paper, IconButton } from "@mui/material";
import ProductionHeader from "./productionHeader";
import ProductionTable from "./productionTable";
import SkeletonView from "../../../components/skeletonView";
import { PollInterval5Min } from "../../../system/utils";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useDimensions from "../../../system/useDimensions";

const ProductionReport = ({ parentSize }: IContentAreaProps): ReactElement => {
  const filter = useSelector<IState, IFilterData>(state => state.filter);
  const [ref, dimensions] = useDimensions<HTMLDivElement>();
  const [open, setOpen] = useState(false);

  const { loading, error, data: response } = useFetch<IProduction[]>(
    {
      module: "production",
      query: "getProductionGanttByFilter",
      payload: { ...filter.remote }
    }, filter.local.mode === "REAL_TIME" ? PollInterval5Min : 0);


  return (
    <div className="display-grid" style={{ ...parentSize, maxHeight: parentSize.height, position: "relative", gridTemplateRows: "auto auto 1fr" }}>
      <FilterComponentBase loading={loading}/>
      {loading && <SkeletonView  parentSize={parentSize}/>}
      {error && <Alert severity="warning">{error.message}</Alert>}
      {!loading && !error && !response && <Alert severity="warning">No Data to Display.</Alert>}

      { response &&
        <Paper className="mb-1 flex-grow-0 display-flex-column p-1" style={{ position: "relative" }}>
          <div className="display-flex-row align-items-center" style={{ position: "relative", left: 0, top: 0 }}>
            <IconButton onClick={() => setOpen(!open)} size={"small"} className="mr-1">
              {open
                ? <ExpandLessIcon fontSize="inherit" fontWeight="bold"/>
                : <ExpandMoreIcon fontSize="inherit" fontWeight="bold"/>
              }
            </IconButton>
            {!open && <strong>General</strong>}
          </div>

          {open && <ProductionHeader productionData={response}/>}
        </Paper>
      }

      <div className="grid-cell" ref={ref}>
        {response && <ProductionTable productionData={response} parentSize={dimensions}  />}
      </div>
    </div>
  );
};

export default ProductionReport;
